module.exports = __webpack_public_path__ + "static/img/home1.e23afcab.png";